var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("FormRoute", {
                attrs: {
                  data: _vm.route,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  dictionaries: _vm.dictionaries,
                  cities: _vm.cities,
                  events: _vm.events,
                  language: _vm.language,
                  isNew: !_vm.id,
                },
                on: {
                  submit: _vm.routeSubmitHandle,
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-routes" })
                  },
                  "delete-route": _vm.deleteRoute,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  "change:descriptionForMobile": function ($event) {
                    return _vm.changeDescForMobHandler($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmRouteRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }